<label *ngIf="!cropperready" (click)="fileUpload.click()" [ngClass]="{'border-succes': fileUploadedtoggle == true}"
    class="file-container " id="validatorcustom">
    <div class="d-inline">
        <span class="file-container-name">{{filename}}</span>
        <span *ngIf="fileUploadedtoggle" class="material-icons align-middle c-save"
            style="padding-bottom: 5px; padding-left:5px;">
            task_alt
        </span>
    </div>
    <span>
        {{selectedFileName || ('fileupload.fileuploadhelp' | trans)}}
    </span>
</label>
<div class="text-center">
    <span *ngIf="cropperready" class="file-container-name">{{filename}}</span>
</div>
<p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.croptofit' | trans }}</p>
<input type="file" (change)="fileChangeEvent($event)" class="d-none" id="validatedCustomFile" #fileUpload required>
<image-cropper *ngIf="imageChangedEvent" class="file-border p-0" [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true" [aspectRatio]="16/9" format="png" [resizeToWidth]="400"
    (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"></image-cropper>
<p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">{{ 'orglogo.previewcrop' | trans }}</p>
<img *ngIf="cropperready" class="m-1 mt-2 w-100 file-border" [src]="croppedImage" />
<div class="row">
    <div class="col">
        <button *ngIf="cropperready" type="button" (click)="logoreset()" class="btn-close mt-2" name="save_rect_">
            <p class="btn-save-text">{{ 'orgstyle.cancel' | trans }}</p>
        </button>
    </div>
    <div class="col">
        <button *ngIf="cropperready" (click)="saveimage()" type="button" class="btn-save mt-2" name="save_rect_">
            <p class="btn-save-text">{{ 'orgsettings.savechanges' | trans }}</p>
        </button>
    </div>
</div>